/**
 * Suma los milisegundos dados a la fecha local actual
 * @param ms Milisegundos
 * @returns {Date}
 */
export const setMillisecondsToDate = (ms: number) => {
  return new Date(new Date().setMilliseconds(ms));
};
